import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { RevenueMeasureField } from './types'

/** Keyed by the whole enum, so adding an actuals value type is a compile error here rather than a
 *  column that quietly reads as no data. */
const MEASURE_FIELD_BY_ACTUALS_TYPE: Record<ActualsValueTypes, RevenueMeasureField | null> = {
  [ActualsValueTypes.None]: null,
  [ActualsValueTypes.Ndp]: 'totalSumNdp',
  [ActualsValueTypes.Net]: 'totalSumNet',
  [ActualsValueTypes.TNet]: 'totalSumTNet',
  [ActualsValueTypes.UTNet]: 'totalSumUTNet',
}

/** Same measures, read in the partner's local currency instead of USD. */
const MEASURE_FIELD_LC_BY_ACTUALS_TYPE: Record<ActualsValueTypes, RevenueMeasureField | null> = {
  [ActualsValueTypes.None]: null,
  [ActualsValueTypes.Ndp]: 'totalSumNdpLc',
  [ActualsValueTypes.Net]: 'totalSumNetLc',
  [ActualsValueTypes.TNet]: 'totalSumTNetLc',
  [ActualsValueTypes.UTNet]: 'totalSumUTNetLc',
}

/** The measure column the configured actuals type reads from, in USD or the partner's local
 *  currency. `null` while the type is unset — it arrives with the same config fetch as the rows,
 *  and guessing a default would show a number that changes once the real value lands. */
export const getRevenueMeasureField = (
  actualsType: ActualsValueTypes,
  isLocalCurrency: boolean
): RevenueMeasureField | null =>
  (isLocalCurrency ? MEASURE_FIELD_LC_BY_ACTUALS_TYPE : MEASURE_FIELD_BY_ACTUALS_TYPE)[
    actualsType
  ] ?? null
